<div class="tooltip">
    <h3 class="tooltip-header">{{fieldLabel}}</h3>
    <p class="tooltip-body">{{textInfo}}</p>
</div>